import React from 'react';
import { TableHead as MuiTableHead, TableRow, TableCell } from '@mui/material';
import { TableColumn, BaseTableRow } from '../types';

interface TableHeadProps<T extends BaseTableRow = BaseTableRow> {
  headers: TableColumn<T>[];
}

export function TableHead<T extends BaseTableRow>({ headers }: TableHeadProps<T>): React.ReactElement {
  console.log('Header====:', headers);
  return (
    <MuiTableHead>
      <TableRow sx={{ backgroundColor: '#E6CED7' }}>
        {headers.map((header) => (
          <TableCell
            key={header.key}
            align={header.align || 'left'}
            sx={{
              backgroundColor: 'background.paper',
              fontWeight: 'bold',
              padding: 0,
              paddingX: '5px',
              width: header.width,
              position: 'sticky',
            }}
          >
            {header.label}
          </TableCell>
        ))}
        <TableCell
          sx={{
            backgroundColor: '#E6CED7',
            fontWeight: 'bold',
            padding: 0,
            paddingX: '5px',
            width: 40,
            position: 'sticky',
            right: 0,
            zIndex: 10,
            textAlign: 'center',
          }}
        >
          Actions
        </TableCell>
      </TableRow>
    </MuiTableHead>
  );
}

